import { useState } from 'react'

import SearchIcon from '@mui/icons-material/Search'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import FormControl from '@mui/material/FormControl'
import Grid from '@mui/material/Grid'
import IconButton from '@mui/material/IconButton'
import LinearProgress from '@mui/material/LinearProgress'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'

import { formatDate } from '../../core/util/date-util'
import { StyledError } from '../../theme/components/StyledError'
import { useAanvraagSearch } from '../hooks/useAanvraagSearch'
import { useImportAanvraag } from '../hooks/useImportAanvraag'

export const AanvraagImporteren = () => {
  const [aanvraagID, setAanvraagID] = useState('')
  const [searchAanvraagID, setSearchAanvraagID] = useState('')
  const {
    data: aanvraagSearchResult,
    isLoading,
    error,
  } = useAanvraagSearch(searchAanvraagID)
  const {
    mutate: importAanvraag,
    isPending: isImporting,
    error: importError,
  } = useImportAanvraag()

  const onClick = () => {
    setSearchAanvraagID(aanvraagID)
  }

  const onClickImporteren = () => {
    importAanvraag({ aanvraagID }, { onSuccess: () => onReset() })
  }

  const onReset = () => {
    setSearchAanvraagID('')
    setAanvraagID('')
  }

  return (
    <Box sx={{ p: 1, width: '95%', mx: 'auto' }}>
      {!aanvraagSearchResult.aanvraagID && (
        <Box>
          <FormControl>
            <TextField
              label="AanvraagID"
              onChange={(ev) => setAanvraagID(ev.target.value)}
            />
          </FormControl>

          <IconButton onClick={onClick}>
            <SearchIcon />
          </IconButton>
        </Box>
      )}
      {!isLoading && (
        <Box sx={{ pt: 2 }}>
          <StyledError error={error || importError} />
        </Box>
      )}
      {aanvraagSearchResult.aanvraagID && (
        <>
          <Box sx={{ width: '95%' }}>
            <Grid sx={{ p: 4, width: '95%', mx: 'auto' }} container>
              <Grid size={{ xs: 4 }}>
                <Typography gutterBottom variant="subtitle1">
                  <b>AanvraagID</b>
                </Typography>
                <Typography variant="body2">
                  {aanvraagSearchResult.aanvraagID}
                </Typography>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Typography gutterBottom variant="subtitle1">
                  <b>Aanvraagdatum</b>
                </Typography>
                <Typography variant="body2">
                  {formatDate(aanvraagSearchResult.aanvraagDatum)}
                </Typography>
              </Grid>
              <Grid size={{ xs: 4 }}>
                <Typography gutterBottom variant="subtitle1">
                  <b>Gebied</b>
                </Typography>
                <Typography variant="body2">
                  {aanvraagSearchResult.gebiedscodeLabel}
                </Typography>
              </Grid>
            </Grid>
          </Box>
          {!isImporting && (
            <Box sx={{ mt: 3 }}>
              <Button variant="contained" onClick={onClickImporteren}>
                Importeren
              </Button>

              <Button sx={{ ml: 2 }} variant="outlined" onClick={onReset}>
                Opnieuw zoeken
              </Button>
            </Box>
          )}
        </>
      )}
      {(isLoading || isImporting) && (
        <LinearProgress
          sx={{
            mt: 2,
            height: '3px',
            backgroundColor: 'rgb(238, 238, 238)',
            background:
              'linear-gradient(to right, rgba(61, 108, 180, 1) 0%, rgba(79, 186, 219, 1) 100%)',
          }}
        />
      )}
    </Box>
  )
}
